<template lang="html">
  <div id="description-page">
    <section class="breadcrumb-section">
      <div class="container oversized-container">
        <span>Producto</span>
        <span class="line">/</span>
        <span>{{ product.category }}</span>
        <span class="line">/</span>
        <span>{{ product.name }}</span>
      </div>
    </section>

    <section class="container med-container description-section" id="product-description">
      <div class="row">

        <div class="col-lg-6 col-gallery" v-if='!icecat'>
          <swiper :options="galleryOptions">
            <swiper-slide v-for="(row, galIndex) in gallery" :key="galIndex">
              <div class="image-container">
                <div class="img">
                  <img :src="row" class="w-100">
                  <!-- <v-zoom :img="row" :width="'100%'"></v-zoom> -->
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>

          <!-- <div class="box-video">
            <iframe src="https://www.youtube.com/embed/yQ_vtTTukq4?si=Aad3F_WR6QZEyEtf" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div> -->
        </div>

        <b-form class="mt-3 mt-lg-0 col-lg-6 col-description" @submit.prevent="quantityValidate()">
          <h1 class="mb-2 name">{{ product.name }}</h1>
          <!-- <h4 class="price discount"><span>$ {{ product.price }}</span></h4> -->
          <!-- <h4 class="price f-w-700 old-price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.oldPrice) }}</h4> -->
          <h4 class="price f-w-600">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} USD</h4>
          <div class="mt-3 b-short-description">
            <div class="b-extras">
              <span class="stock">{{ product.stock }} DISPONIBLES</span>

              <span class="shipping"><i class="fa-solid fa-truck-fast"></i> 2 A 4 DIAS HABILES</span>
            </div>
            <!-- <h6><span class="label">Potecia</span> <span class="txt-1">6 HP a 24,000 RPM’s</span></h6>
            <h6><span class="label">Area util</span> (X)1220 x (Y) 2440 X (Z) 200 mm</h6>
            <h6><span class="label">Velocidad de avance</span> 35,000 mm/min</h6>
            <h6><span class="label">Precisión +/-</span> 0.15 mm</h6> -->

            <div class="descr">
              <p>{{ product.description }}</p>
            </div>
          </div>

          <!-- <div class="mt-3 mb-3 accordion-no-border" role="tablist">
            <b-card no-body>
              <b-card-header header-tag="header" role="tab">
                <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-1>CARACTERÍSTICAS <i class="icon"></i></h6>
              </b-card-header>

              <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <p class="mt-2 extra-breadcrumb">
                    <span><strong class="f-w-600">SKU: </strong> {{ product.sku }}<br /></span>
                  </p>

                  <div class="box-categories-brands">
                    <p class="mt-2 extra-breadcrumb">
                      <span v-if="product.category"><strong class="f-w-600">Categoria: </strong> <router-link class="buble" target="_blank" :to="'/categoria/'+$root._converToURL(product.category, product.category_id)">{{ product.category }}</router-link> <br /></span>
                    </p>
                    <p class="mt-2 extra-breadcrumb">
                      <span v-if="product.subcategory"><strong class="f-w-600">Subcategoria: </strong> <router-link class="buble" target="_blank" :to="'/subcategoria/'+$root._converToURL(product.subcategory, product.subcategory_id)">{{ product.subcategory }}</router-link> <br /></span>
                    </p>
                    <p class="mt-2 extra-breadcrumb" v-if="product.marca">
                      <span><strong class="f-w-600">Marca:</strong></span> <router-link class="buble" target="_blank"  :to="'/marca/'+$root._converToURL(product.marca, product.marca_id)"> {{ product.marca }}</router-link>
                    </p>
                  </div>

                  <div class="txt-description">
                    <p>
                      Conoce los beneficios y propiedades.
                    </p>

                    <div class="box-features">
                      <ul class="check-list">
                        <li>
                          <h6>Fabricación</h6>
                          <p>
                            Fabricada con materia prima de alta calidad con base en una película de respaldo de polipropileno biorientado y adhesivos sintéticos a base de agua.
                          </p>
                        </li>

                        <li>
                          <h6>Propiedades</h6>
                          <p>
                            - Alta adaptación
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="mt-1 extra-breadcrumb">
                    <span v-if="product.ancho"><strong>Ancho:</strong> {{ product.ancho }} metros. </span>
                    <span v-if="product.alto"><strong>Alto:</strong> {{ product.alto }} metros. </span>
                    <span v-if="product.largo"><strong>Largo:</strong> {{ product.largo }} metros. </span>
                    <span v-if="product.volumen"><strong>Volumen:</strong> {{ product.volumen }}. </span>
                    <span v-if="product.peso"><strong>Peso:</strong> {{ product.peso }} kg. </span>
                    <span v-if="product.material"><strong>Material:</strong> {{ product.material }}.</span>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div> -->

          <!-- <div class="mt-1 extra-breadcrumb" v-if="product.ancho">Ancho: {{ product.ancho }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.alto">Alto: {{ product.alto }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.largo">Largo: {{ product.largo }} cm</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.volumen">Volumen: {{ product.volumen }}</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.peso">Peso: {{ product.peso }} kg</div>
          <div class="mt-1 extra-breadcrumb" v-if="product.material">Material: {{ product.material }}</div> -->

          <h6 class="mt-2 subtitle" v-if="product.ficha">Ficha tecnica</h6>
          <div class="txt-description" v-if="product.ficha" v-html="product.ficha"></div>

          <h6 class="subtitle" v-if="product.color">Color</h6>
          <h4 class="price" v-if="product.color">{{ product.color }}</h4>

          <!-- Stock -->
          <!-- <div class="mt-2 extra-breadcrumb">
            <span><strong>Disponibilidad:</strong> En existencias</span>
          </div> -->

          <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-colors>COLORES <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-colors" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="pb-2">
                    <div class="box-colors">
                      <b-form-radio-group
                        v-model="form.color"
                        name="radio-comp">
                        <b-form-radio :value="c.id" v-for="(c, cInx) in product.colors" :key="'cInx-'+cInx">
                          <div class="color-opt" v-bind:style="{ backgroundColor: c.color_code }"></div>
                        </b-form-radio>
                      </b-form-radio-group>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>

          <!-- <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-bord>AGREGAR BORDADO <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-bord" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="pb-2">
                    <div class="pt-2 pb-1">
                      <b-form-group class="custom-f-group">
                        <b-form-input
                          v-model="form.bordado"
                          type="text"
                          placeholder="Max. 20 caracteres"
                          maxlength="20"
                          required
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group class="mb-0 custom-f-group typo-select-group">
                        <b-form-select v-model="form.tipografia">
                          <b-form-select-option :value="null">Seleccione una tipografía</b-form-select-option>
                          <b-form-select-option value="1">Arial</b-form-select-option>
                          <b-form-select-option value="2">Verdana</b-form-select-option>
                          <b-form-select-option value="3">Trebuchet MS</b-form-select-option>
                          <b-form-select-option value="4">Times New Roman</b-form-select-option>
                          <b-form-select-option value="5">Georgia</b-form-select-option>
                          <b-form-select-option value="6">Courier New</b-form-select-option>
                          <b-form-select-option value="7">Brush Script MT</b-form-select-option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div> -->

          <!-- <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-extras>EXTRAS <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-extras" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="pb-2">
                    <div class="box-extras">
                      <b-form-checkbox-group class="checkbox-group">
                        <b-form-checkbox value="1">
                          <h5 class="e-title">Extra de ejemplo</h5>
                          <h4 class="e-price">$150.00</h4>
                          <p class="e-descr">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                          </p>
                        </b-form-checkbox>
                        <b-form-checkbox value="2">
                          <h5 class="e-title">Extra de ejemplo 2</h5>
                          <h4 class="e-price">$89.98</h4>
                          <p class="e-descr">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                          </p>
                        </b-form-checkbox>
                      </b-form-checkbox-group>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div> -->

          <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-2>MEDIDAS <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="pb-2">
                    <div v-html="product.sizes"></div>
                    <!-- <div class="mt-1 extra-breadcrumb">
                      <span v-if="product.ancho"><strong>Ancho:</strong> {{ product.ancho }} cm. </span>
                      <span v-if="product.alto"><strong>Alto:</strong> {{ product.alto }} cm. </span>
                      <span v-if="product.largo"><strong>Largo:</strong> {{ product.largo }} cm. </span>
                      <span v-if="product.volumen"><strong>Volumen:</strong> {{ product.volumen }}. </span>
                      <span v-if="product.peso"><strong>Peso:</strong> {{ product.peso }} kg. </span>
                      <span v-if="product.material"><strong>Material:</strong> {{ product.material }}.</span>
                    </div> -->

                    <!-- <div class="d-block pb-1">
                      <img class="img-fluid" src="public/images/pages/products/table-1.png">
                    </div> -->
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>

          <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-3>PREGUNTAS FRECUENTES <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="d-block py-1">
                      <div class="d-block b-faqs" v-html="product.faqs"></div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>

          <!-- <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-4>DESCARGAS <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="row pb-1">
                      <div class="col-lg-6 col-download py-2">
                        <a class="w-100 btn btn-outline" href="">FICHA TÉCNICA</a>
                      </div>

                      <div class="col-lg-6 col-download py-2">
                        <a class="w-100 btn btn-outline" href="">GALERÍA</a>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div> -->

          <!-- <div>
            <div class="mt-3 mb-3 accordion-no-border" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h6 class="subtitle btn-toggleable" v-b-toggle.accordion-5>VIDEO <i class="icon"></i></h6>
                </b-card-header>

                <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="box-video">
                      <iframe src="https://www.youtube.com/embed/" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div> -->
          <!--  -->

          <!-- <h4 class="pt-2 price f-w-700">Desde $ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} más IVA</h4> -->

          <h6 class="mt-4 subtitle">Compartir</h6>
          <div class="col-12 mt-1 col-extra col-networks" id="col-extra">
            <div class="row">
              <!-- <div class="col b-print">
                <div class="btn-q" @click="printDiv('product-description')"><span><i class="fas fa-print"></i></span></div>
              </div> -->

              <div class="col px-0 b-sharing">
                <ShareNetwork
                  v-for="(network, pdInx) in networks"
                  :network="network.network"
                  :key="network.network"
                  :style="{backgroundColor: network.color}"
                  :url="sharing.url"
                  :title="sharing.title"
                  :description="sharing.description"
                  :quote="sharing.quote"
                  :hashtags="sharing.hashtags"
                  :twitterUser="sharing.twitterUser">
                  <div class="btn-q"><span><i :class="network.icon"></i></span></div>
                </ShareNetwork>

              </div>
            </div>
          </div>

          <div class="row mt-4 row-quantity-button">
            <!-- <div class="col-12 col-btn-send mb-3">
              <a class="w-100 btn btn-submit c2">DESDE $ <span class="f-w-700">{{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</span> MÁS IVA</a>
            </div> -->

            <div class="col-lg col-quantity">
              <h6 class="subtitle" v-if="product.stock">Cantidad</h6>
              <div class="row no-gutters pt-1 box-options" v-if="product.stock">
                <div class="col col-short">
                  <b-form-input v-model="form.quantity" type="number" class="text-center" required></b-form-input>
                </div>
              </div>
            </div>

            <div class="col-lg pl-lg-0 mt-3 mt-lg-2 col-btn-send">
              <b-button type="submit" class="w-100 btn-submit c3">COMPRAR <i class="fa-solid fa-cart-shopping"></i></b-button>
            </div>

            <!-- <div class="col-12 col-btn-send">
              <router-link class="w-100 btn btn-submit c1" to="/contacto">SOLICITAR COTIZACIÓN</router-link>
            </div> -->
          </div>

          <div class="d-block mt-4 mb-2" v-if="product.pdf">
            <a class="btn btn-submit btn-contact" v-if="product.pdf" :href="product.pdf" target="_blank" rel="noopener noreferrer">PDF <i class="fa fa-file-pdf-o"></i></a>
          </div>

          <div class="col-12 my-2">
            <div class="row">
              <div class="col-sm-6 my-2 px-0 pr-sm-3" v-if="product.stock">
                <!-- <b-button type="submit" class="w-100 btn-submit">AGREGAR AL CARRITO <i class="fa-solid fa-cart-shopping"></i></b-button> -->
              </div>

              <div class="col-sm-6 my-2 px-0 pl-sm-3">
                <!-- <router-link class="w-100 btn btn-submit btn-contact" :to="{ name: 'contacto', query: { p: product.name+', SKU: '+product.sku } }">Contactar <i class="far fa-envelope"></i></router-link> -->
              </div>
            </div>
          </div>

          <!-- <h6 class="subtitle">Inventarios</h6>
          <div class="col-12 mt-2 col-extra" id="col-extra">
            <table id="stocktable">
                <tr>
                  <th>Almacen</th>
                  <th>Stock</th>
                </tr>
                <tr v-for="(st,indx) in product.stocks" :key="indx">
                  <td>{{st.warehouse}}</td>
                  <td>{{st.stock}}</td>
                </tr>
            </table>
          </div> -->
        </b-form>

        <!-- <div class="col-12 mb-2">
          <div class="col-12 px-0 col-s-title">
            <h2 class="title">Comentarios</h2>
            <hr class="mt-2 mb-0" />
          </div>
        </div> -->

        <!-- <div class="col-lg-6 col-comment-form">
          <div class="col-12 col-comments">
            <b-form class="box-comment" @submit="addComment">
              <h5 class="subt">Califica este producto</h5>

              <div class="box-stars">
                <b-form-rating inline required v-model="comment.stars" stars="5"></b-form-rating>
              </div>

              <div class="box-input">
                <b-form-textarea v-model="comment.body" placeholder="Escribe tu comentario" required rows="2" max-rows="2"></b-form-textarea>

                <p class="mt-2 text-right">
                  <b-button type="submit" class="btn-co">Comentar</b-button>
                </p>
              </div>
            </b-form>
          </div>
        </div>

        <div class="col-lg-6 mt-3 col-all-comments">
          <div class="wr-comments" v-if="comments.length">
            <div class="row">

              <div class="col-12 col-total-comments" v-if="avg > 0">
                <div class="box"><small>TOTAL:</small> {{ Math.ceil(avg) }}</div>
              </div>

              <div class="col-12 col-comments">
                <div class="row">
                  <div class="col-lg-6 col-comment" v-for="(item, coprInx) in comments" :key="'coprInx-'+coprInx">
                    <div class="box">
                      <div class="box-stars">
                        <b-form-rating v-model="item.star" readonly inline></b-form-rating>
                      </div>

                      <div class="box-comment">{{ item.comment }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-11 mx-auto col-extrainfo" v-if="icecat">
            <div id="Container5"></div>
            <div id="Container7"></div>
            <div id="Container11"></div>
        </div> -->

      </div>

    </section>

    <section class="container med-container related-products-section" id="related-products">
      <div class="row">
        <div class="col-12 px-2 col-s-title">
          <h2 class="text-center title-s1">PRODUCTOS RELACIONADOS</h2>
          <hr class="mt-2 mb-2" />
        </div>
      </div>

      <div class="row">
        <div class="col-12 px-0 col-products">
          <swiper class="swiper carousel-t1" :options="productsOption">
            <swiper-slide v-for="(prd, pInx) in products" :key="'pInx-'+pInx">
              <div class="col-12 px-0 sample-product shad-prod">
                <a class="outlined-box">
                  <router-link class="fake-link" :to="'/producto/'+$root._converToURL(prd.name, prd.id)"></router-link>

                  <div class="box-image">
                    <div class="out-of-stock" v-if="prd.stock < 1">Agotado</div>

                    <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+prd.image+')' }">
                      <img src="public/images/pages/products/product.png" >
                    </div>
                  </div>

                  <div class="box-shot-descr">
                    <h6 class="brand">{{ prd.sku }}</h6>
                    <h6 class="name">{{ prd.name }}</h6>
                    <div class="b-type" v-if="prd.stock">
                      <div class="type s2">{{ prd.stock }} DISPONIBLES</div>
                    </div>
                    <!-- <h6 class="brand">{{ prd.brand }}</h6> -->
                    <!-- <h6 class="price discount"><span>$ {{ prd.price }}</span></h6> -->
                    <h6 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(prd.price) }} USD</h6>
                  </div>

                  <cart-component :product="prd"></cart-component>
                </a>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </section>

    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
      <div v-html="modal.msg"></div>
      <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close()">Agregar mas productos</b-button>
        <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close(); $router.push('/cart')">Ir al carrito <i class="color-white fas fa-shopping-cart"></i></b-button>
      </div>
    </sweet-modal>

    <loading-bg-component v-if="isLoading"></loading-bg-component>

  </div>
</template>

<script>
import vZoom from 'vue-zoom'; // https://www.npmjs.com/package/vue-zoom
export default {
  components: {vZoom},

  data() {
    return {
      id: null,
      isLoading: true,

      form: {
        quantity: 1,
        color: null,
        bordado: null,
        tipografia: null,
        extras: [],
      },

      gallery: [
        // 'public/images/pages/products/product-xl.jpg',
      ],

      product: {
        id: 2,
        name: null,
        sku: null,
        category_id: null,
        category: null,
        subcategory_id: '5',
        subcategory: null,
        price: 0,
        oldPrice: '0',
        marca_id: 1,
        marca: null,
        description: null,
        stock: 35,
        ancho: 15,
        alto: 9,
        largo: 15,
        peso: 0.05,
        stocks:[],
      },
      category: [],
      products: [
        // {
        //   id: 1,
        //   sku: "63423",
        //   name: "CORONA T-358 PLATA",
        //   price: "75.00",
        //   stock: 1,
        //   imageUrl: "public/images/pages/products/product-1.jpg"
        // },
      ],
      sizes: [],
      size: [],
      stock: 0,
      avg: 0,
      favorite: false,
      icecat: false,

      // == Sharing ==
      sharing: {
        url: 'https://xvshopping.online/#/producto/',
        title: 'XV Shopping',
        description: 'Esto es un ejemplo de descripción',
        quote: 'Esto es el Quote',
        hashtags: 'this,isthe,hashtag',
        twitterUser: 'twitter'
      },

      networks: [
        { network: 'twitter', name: 'Twitter', icon: 'fa-brands fa-x-twitter' },
        { network: 'facebook', name: 'Facebook', icon: 'fab fa-facebook-f' },
        { network: 'email', name: 'Email', icon: 'fas fa-envelope' },
        { network: 'whatsapp', name: 'WhatsApp', icon: 'fab fa-whatsapp' },
      ],
      // == ==

      colors: [
        { id: 1, color_code: '#ffffff' },
        { id: 2, color_code: '#b6b3b3' },
        { id: 3, color_code: '#727070' },
        { id: 4, color_code: '#3d3c3c' },
        { id: 5, color_code: '#151414' },
        { id: 6, color_code: '#ff0184' },
        { id: 7, color_code: '#da0271' },
        { id: 8, color_code: '#da02b9' },
        { id: 9, color_code: '#b6089b' },
        { id: 10, color_code: '#9008b6' },
        { id: 11, color_code: '#44079d' },
        { id: 12, color_code: '#672ee5' },
        { id: 13, color_code: '#2295e9' },
        { id: 14, color_code: '#332ee5' },
        { id: 15, color_code: '#7471e3' },
        { id: 16, color_code: '#56d22a' },
        { id: 17, color_code: '#b5e531' },
        { id: 18, color_code: '#e5b031' },
        { id: 19, color_code: '#c78f07' },
        { id: 20, color_code: '#c72207' },
        { id: 21, color_code: '#eb2222' },
      ],

      relatedProducts: [],

      comments: [],

      modal:{
        msg:'',
        icon:'',
        block:false
      },

      comment:{
        stars: null,
        body: ''
      },

      // == Carrusel options ==
      galleryOptions: {
        loop: false,
        speed: 600,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false
        // }
      },

      productsOption: {
        loop: false,
        slidesPerView: 4,
        spaceBetween: 4,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1200: {
            spaceBetween: 0,
            slidesPerView: 4
          },
          992: {
            spaceBetween: 0,
            slidesPerView: 3
          },
          768: {
            spaceBetween: 0,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        effect: 'slide',
        speed: 600
      },
      // == ==
    }
  },

  watch: {
    "$route.params.id" : function(v){
      //this.id = this.$route.params.id;
      this.id = this.$root._getURLID(this.$route.params.id);
      this.getProduct();
    }
  },

  methods:{
    toast(title, msg, variant) {
      this.$bvToast.toast(msg, {
        title: title,
        toaster: 'b-toaster-bottom-right',
        variant: variant,
        solid: true,
        appendToast: true
      })
    },

    copyLink(value) {
      navigator.clipboard.writeText(value);
      // alert('Link copiado');
      this.toast('Pago seguro ', 'Link copiado correctamente', 'success');
    },

    getComments(id){
      axios.get(tools.url('/api/comments/'+id)).then((response)=>{
        this.comments = response.data.comments;
        this.avg = response.data.avg;

      }).catch((error)=>{
        console.log(error);
      })
    },

    addComment: function(){
        axios.post(tools.url("/api/comments/"+this.product.id),{stars:this.comment.stars, comment:this.comment.body}).then((response) => {
            this.comment.stars = null;
            this.comment.body = '';
            this.getComments(this.id);
        }).catch((error) => {
            alert("Error al agregar comentario");
            console.log(error);
        })
    },

    quantityValidate(){
      var w = 'piezas';
      if(this.form.quantity > this.product.stock){
        console.log(this.product.stock);
        
        if(this.product.stock <= 1){ w = 'pieza' };
        this.toast('Error', 'Este artículo cuenta con maximo '+this.product.stock+' '+w+' en existencia', 'danger');
      }else{
        this.stock = this.product.stock;
        this.addCart();
      }
    },

    getProduct(){
      this.isLoading = true;

      axios.get(tools.url('/api/product/' + this.id)).then((response)=>{
        this.gallery = [];
        this.product = response.data;
        this.category = response.data.category;
        this.gallery[0] = response.data.image;
        this.isLoading = false;

        if(this.product.stock > 0){
          this.form.quantity = 1;
        }

        this.getRelated();
        //this.getComments(this.product.id);
      }).catch((error)=>{
        console.log(error);
      });
    },

    addCart(){
      var cart = [];
      var encontrado = false;

      if(this.form.quantity > 0){
          if(localStorage.cart){
            cart = JSON.parse(localStorage.getItem('cart'));

            for(var i = 0; i < cart.length ; i++){
              if(cart[i].id == this.id){
                var suma = Number(cart[i].quantity) + Number(this.form.quantity);
                cart[i].quantity = suma <= this.stock ? suma : this.stock;
                encontrado = true;
                break;
              }
            }

            if(!encontrado){
              cart.push({ id:this.id, quantity:this.form.quantity });
            }
          } else{
            cart.push({ id:this.id, quantity:this.form.quantity });
          }

          localStorage.setItem("cart",JSON.stringify(cart));
          this.$root.cartCount = cart.length;
          this.modal.msg = 'El producto <b>'+this.product.name+'</b> se agregado al carrito con '+this.form.quantity+' piezas';
          this.modal.icon = 'success';
          this.$refs.modal.open();
      }

    },

    getRelated(){
      let productInfo = {
        productId: this.product.id,
        categoryID: this.product.categories_id,
      };

      axios.post(tools.url('/api/products/related/'),productInfo).then((response)=>{
        this.products = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },

    getFavorite: function(){
        if(this.$root.user.id){
            axios.post(tools.url('/api/favorite'),{ product_id: this.id }).then((response)=>{
                if(response.data == 'true'){
                    this.favorite = true;
                }else{
                    this.favorite = false;
                }
                this.favoritesCount();
            }).catch((error)=>{
                console.log(error);
            });
        }
    },

    addFavorite: function(){
        if(this.$root.user.id){
            axios.post(tools.url('/api/addFavorite'),{product_id: this.id }).then((response)=>{
                this.favorite = response.data.favorite;
                this.favoritesCount();
            }).catch((error)=>{
                console.log(error);
            });
        }
    },

    favoritesCount: function(){
        if(this.$root.user.id){
            axios.get(tools.url('/api/favoritesCount')).then((response)=>{
                this.$root.favoriteCount = response.data;
            }).catch((error)=>{
                console.log(error);
            })
        }
    }

  },

  mounted(){
    this.id = this.$route.params.id;
    this.id = this.$root._getURLID(this.$route.params.id);
    this.getProduct();

    /*if(this.$root.logged == true){
        this.getFavorite();
    }*/
  }
}
</script>
<style>
#stocktable table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#stocktable td {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
#stocktable th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  background-color: #dddddd;
}
</style>
